import { NotificationAPI } from '@/api'

import { SET_TARGET_STATUS } from '../../../views/audienceHub/store/actions'
import { TYPES } from '../notificationConstants'

const module = 'NOTIFICATIONS_'

export const SET_NOTIFICATIONS = module + 'SET_NOTIFICATIONS'
export const REMOVE_NOTIFICATION = module + 'REMOVE_NOTIFICATION'
export const DELETE_NOTIFICATION = module + 'DELETE_NOTIFICATION'
export const UPDATE_NOTIFICATION = module + 'UPDATE_NOTIFICATION'

const actions = {
  [DELETE_NOTIFICATION] (context, notification) {
    // TODO UI notification that says the Notification was deleted.
    notification.user_id = context.rootState.auth.username
    NotificationAPI.deleteNotification(notification)
    context.commit(DELETE_NOTIFICATION, notification)
  },
  [UPDATE_NOTIFICATION] (context, notification) {
    context.commit(UPDATE_NOTIFICATION, notification)
  },
  [SET_NOTIFICATIONS] (context, user) {
    NotificationAPI.getNotifications({ user_id: user }).then(data => {
      context.commit(SET_NOTIFICATIONS, {
        notifications: data,
        user,
      })
      if (data.notification_type === TYPES.ATT_RESPONSE) {
        context.commit(SET_TARGET_STATUS, JSON.parse(data.body))
      }
    })
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/app/appLogic/notifications/store/actions.js